import clsx from "clsx";

import { JSX, useState } from "react";

import IconStarRating from "@/components/icons/IconStarRating.tsx";

const colors: Record<number, string> = {
  0: "fill-[#FADD01]",
  1: "fill-[#FC9101]",
  2: "fill-[#FD4D01]",
  3: "fill-[#FF1301]",
  4: "fill-[#FF2201]",
  5: "fill-[#FF2F01]",
  6: "fill-[#FF3C01]",
  7: "fill-[#FF4901]",
  8: "fill-[#FF5601]",
  9: "fill-[#FF6501]",
};

const Stars = ({ rating, onChange }: { rating: number; onChange: (value: number) => void }): JSX.Element => {
  const [hovered, setHovered] = useState<number>(-1);

  const getFillColor = (index: number) => {
    if (hovered >= 0) {
      return index <= hovered ? colors[index] : "fill-on-surface";
    }
    return index <= rating ? colors[index] : "fill-on-surface";
  };

  return (
    <div className={"flex items-center"}>
      {[...Array(10).keys()].map((_, i) => (
        <button
          type={"button"}
          onClick={() => onChange(i)}
          onMouseOver={() => setHovered(i)}
          onMouseLeave={() => setHovered(-1)}
          key={i}
          className={clsx(
            "relative flex items-center  justify-center text-xl/tight  max-xl:text-sm max-md:text-[3vw]",
            {
              "px-1.5 max-md:px-[0.9vw]": i > 0 && i < 9,
            },
          )}
        >
          <IconStarRating
            className={clsx(
              "size-16 transition-colors max-xl:size-10 max-lg:size-8 max-md:size-[8vw]",
              getFillColor(i),
            )}
          />
          <span className={"absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/3 transform text-black"}>
            {i + 1}
          </span>
        </button>
      ))}
    </div>
  );
};

export default Stars;
